export const earlyReservation = {
  bottomSection: null,
}
